import type { ButtonProps } from 'antd';
import { Button } from 'antd';

import styles from '../StepIntro.module.scss';

type OptionCardProps = {
  category: string;
  title: string;
  subtitle: string | React.ReactNode;
  children: React.ReactNode;
  buttonLabel: string;
  buttonProps?: ButtonProps;
  onButtonClick: () => void;
  disabled?: boolean;
};

export const OptionCard = ({
  category,
  title,
  subtitle,
  children,
  buttonLabel,
  buttonProps,
  onButtonClick,
  disabled,
}: OptionCardProps) => (
  <div className={styles.option}>
    <div className={styles.optionContent}>
      <div className={styles.optionHeader}>
        <span className={styles.optionLabel}>{category}</span>
        <div className={styles.optionText}>
          <p className={styles.optionTitle}>{title}</p>
          <div className={styles.optionSubtitle}>{subtitle}</div>
        </div>
      </div>
      {children}
    </div>
    <Button
      className={styles.optionCTA}
      onClick={onButtonClick}
      disabled={disabled}
      {...buttonProps}
    >
      {buttonLabel}
    </Button>
  </div>
);
